module.exports = __webpack_public_path__ + "static/img/bg_1.bbc2e65.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg_1.png
// module id = 0N86
// module chunks = 1